import { __awaiter, __generator } from "tslib";
import { Component, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { EventViewMode, Properties, } from './../services/definitions.service';
import { AddEventComponent } from './dialogs/add-event/add-event.component';
import 'firebase/firestore';
import { FormControl } from '@angular/forms';
import { groupBy } from 'lodash';
import { EventState } from '../testing/mock-common-functions.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/data-model.service";
import * as i2 from "../services/common-functions.service";
import * as i3 from "../services/log.service";
import * as i4 from "@angular/material/dialog";
import * as i5 from "ngx-device-detector";
import * as i6 from "../services/auth.service";
import * as i7 from "@angular/material/tabs";
import * as i8 from "@angular/common";
import * as i9 from "@angular/material/form-field";
import * as i10 from "@angular/material/select";
import * as i11 from "@angular/forms";
import * as i12 from "./components/event-view/event-view.component";
import * as i13 from "@angular/material/core";
import * as i14 from "@angular/material/slide-toggle";
import * as i15 from "@angular/material/tooltip";
import * as i16 from "@angular/material/card";
import * as i17 from "@angular/material/table";
import * as i18 from "@angular/material/button";
import * as i19 from "@angular/material/icon";
function EventsAdminComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " Aktuell ");
} }
function EventsAdminComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    var _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "event-view", 13);
    i0.ɵɵlistener("componentChanged", function EventsAdminComponent_div_4_Template_event_view_componentChanged_1_listener($event) { i0.ɵɵrestoreView(_r17); var ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.eventChanged($event); })("componentLoaded", function EventsAdminComponent_div_4_Template_event_view_componentLoaded_1_listener($event) { i0.ɵɵrestoreView(_r17); var ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.subComponentIsLoaded($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var data_r14 = ctx.$implicit;
    var ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", data_r14)("users", ctx_r1.users)("userOptions", ctx_r1.userOptions)("accountingYear", ctx_r1.accountingYear)("viewMode", ctx_r1.viewMode);
} }
function EventsAdminComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "Keine Events vorhanden");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " Zukunft ");
} }
function EventsAdminComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    var _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "event-view", 13);
    i0.ɵɵlistener("componentChanged", function EventsAdminComponent_div_8_Template_event_view_componentChanged_1_listener($event) { i0.ɵɵrestoreView(_r22); var ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.eventChanged($event); })("componentLoaded", function EventsAdminComponent_div_8_Template_event_view_componentLoaded_1_listener($event) { i0.ɵɵrestoreView(_r22); var ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.subComponentIsLoaded($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var data_r19 = ctx.$implicit;
    var ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", data_r19)("users", ctx_r4.users)("userOptions", ctx_r4.userOptions)("accountingYear", ctx_r4.accountingYear)("viewMode", ctx_r4.viewMode);
} }
function EventsAdminComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "Keine Events vorhanden");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " Beendet ");
} }
function EventsAdminComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    var _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "event-view", 13);
    i0.ɵɵlistener("componentChanged", function EventsAdminComponent_div_12_Template_event_view_componentChanged_1_listener($event) { i0.ɵɵrestoreView(_r27); var ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.eventChanged($event); })("componentLoaded", function EventsAdminComponent_div_12_Template_event_view_componentLoaded_1_listener($event) { i0.ɵɵrestoreView(_r27); var ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.subComponentIsLoaded($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var data_r24 = ctx.$implicit;
    var ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", data_r24)("users", ctx_r7.users)("userOptions", ctx_r7.userOptions)("accountingYear", ctx_r7.accountingYear)("viewMode", ctx_r7.viewMode);
} }
function EventsAdminComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "Keine Events vorhanden");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " Schicht-\u00DCbersicht ");
} }
function EventsAdminComponent_mat_option_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var event_r29 = ctx.$implicit;
    var ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", event_r29.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", event_r29.name, " ", ctx_r10.shiftIsPassed(event_r29) ? "(beendet)" : "", " ");
} }
function EventsAdminComponent_mat_slide_toggle_22_Template(rf, ctx) { if (rf & 1) {
    var _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-slide-toggle", 16);
    i0.ɵɵlistener("change", function EventsAdminComponent_mat_slide_toggle_22_Template_mat_slide_toggle_change_0_listener($event) { i0.ɵɵrestoreView(_r31); var ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.onChangeShowNames($event); });
    i0.ɵɵtext(1, "Namen ausblenden");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r11.showNames);
} }
function EventsAdminComponent_div_24_div_6_mat_header_cell_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Schicht-Name ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_24_div_6_mat_cell_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r48 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", shift_r48.type, " ");
} }
function EventsAdminComponent_div_24_div_6_mat_header_cell_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Schichtleiter ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_24_div_6_mat_cell_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r49 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", shift_r49.responsiblePerson, " ");
} }
function EventsAdminComponent_div_24_div_6_mat_header_cell_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Start ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_24_div_6_mat_cell_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r50 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, shift_r50.start.toDate(), "HH:mm"), " Uhr ");
} }
function EventsAdminComponent_div_24_div_6_mat_header_cell_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Ende ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_24_div_6_mat_cell_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r51 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, shift_r51.end.toDate(), "HH:mm"), " Uhr ");
} }
function EventsAdminComponent_div_24_div_6_mat_header_cell_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Freie Pl\u00E4tze ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_24_div_6_mat_cell_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r52 = ctx.$implicit;
    var ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r43.calcFreePlaces(shift_r52), " ");
} }
function EventsAdminComponent_div_24_div_6_mat_header_cell_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Teilnehmer ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_24_div_6_mat_cell_21_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var idx_r56 = i0.ɵɵnextContext().index;
    var shift_r53 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", shift_r53.participants && shift_r53.participants[idx_r56] ? shift_r53.participants[idx_r56].firstName + " " + shift_r53.participants[idx_r56].lastName : "Nicht belegt", " ");
} }
var _c0 = function (a0, a1) { return { occupied: a0, empty: a1 }; };
function EventsAdminComponent_div_24_div_6_mat_cell_21_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtemplate(1, EventsAdminComponent_div_24_div_6_mat_cell_21_div_2_div_1_Template, 2, 1, "div", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var idx_r56 = ctx.index;
    var shift_r53 = i0.ɵɵnextContext().$implicit;
    var ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0, shift_r53.participants && shift_r53.participants[idx_r56], !(shift_r53.participants && shift_r53.participants[idx_r56])));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r54.hideNames);
} }
var _c1 = function () { return []; };
function EventsAdminComponent_div_24_div_6_mat_cell_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵtemplate(2, EventsAdminComponent_div_24_div_6_mat_cell_21_div_2_Template, 2, 5, "div", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r53 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(shift_r53.minParticipants));
} }
function EventsAdminComponent_div_24_div_6_mat_header_row_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
} }
function EventsAdminComponent_div_24_div_6_mat_row_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-row");
} }
var _c2 = function () { return ["name", "responsiblePerson", "start", "end", "freePlaces", "participants"]; };
function EventsAdminComponent_div_24_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "table", 21);
    i0.ɵɵelementContainerStart(4, 22);
    i0.ɵɵtemplate(5, EventsAdminComponent_div_24_div_6_mat_header_cell_5_Template, 2, 0, "mat-header-cell", 23);
    i0.ɵɵtemplate(6, EventsAdminComponent_div_24_div_6_mat_cell_6_Template, 3, 1, "mat-cell", 24);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(7, 25);
    i0.ɵɵtemplate(8, EventsAdminComponent_div_24_div_6_mat_header_cell_8_Template, 2, 0, "mat-header-cell", 23);
    i0.ɵɵtemplate(9, EventsAdminComponent_div_24_div_6_mat_cell_9_Template, 2, 1, "mat-cell", 24);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(10, 26);
    i0.ɵɵtemplate(11, EventsAdminComponent_div_24_div_6_mat_header_cell_11_Template, 2, 0, "mat-header-cell", 23);
    i0.ɵɵtemplate(12, EventsAdminComponent_div_24_div_6_mat_cell_12_Template, 3, 4, "mat-cell", 24);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(13, 27);
    i0.ɵɵtemplate(14, EventsAdminComponent_div_24_div_6_mat_header_cell_14_Template, 2, 0, "mat-header-cell", 23);
    i0.ɵɵtemplate(15, EventsAdminComponent_div_24_div_6_mat_cell_15_Template, 3, 4, "mat-cell", 24);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(16, 28);
    i0.ɵɵtemplate(17, EventsAdminComponent_div_24_div_6_mat_header_cell_17_Template, 2, 0, "mat-header-cell", 23);
    i0.ɵɵtemplate(18, EventsAdminComponent_div_24_div_6_mat_cell_18_Template, 2, 1, "mat-cell", 24);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(19, 29);
    i0.ɵɵtemplate(20, EventsAdminComponent_div_24_div_6_mat_header_cell_20_Template, 2, 0, "mat-header-cell", 23);
    i0.ɵɵtemplate(21, EventsAdminComponent_div_24_div_6_mat_cell_21_Template, 3, 2, "mat-cell", 24);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(22, EventsAdminComponent_div_24_div_6_mat_header_row_22_Template, 1, 0, "mat-header-row", 30);
    i0.ɵɵtemplate(23, EventsAdminComponent_div_24_div_6_mat_row_23_Template, 1, 0, "mat-row", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var day_r33 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(day_r33.day);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dataSource", day_r33.shifts);
    i0.ɵɵadvance(19);
    i0.ɵɵproperty("matHeaderRowDef", i0.ɵɵpureFunction0(4, _c2));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(5, _c2));
} }
function EventsAdminComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "mat-card", 18);
    i0.ɵɵelementStart(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, EventsAdminComponent_div_24_div_6_Template, 24, 6, "div", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r12.selectedEvent.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r12.selectedEvent.description);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r12.getShiftsByDay(ctx_r12.selectedEvent.workPackages));
} }
function EventsAdminComponent_button_25_Template(rf, ctx) { if (rf & 1) {
    var _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function EventsAdminComponent_button_25_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r63); var ctx_r62 = i0.ɵɵnextContext(); return ctx_r62.addEvent(); });
    i0.ɵɵelementStart(1, "mat-icon", 37);
    i0.ɵɵtext(2, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
var EventsAdminComponent = /** @class */ (function () {
    function EventsAdminComponent(dataModel, common, log, dialog, deviceService, authService) {
        this.dataModel = dataModel;
        this.common = common;
        this.log = log;
        this.dialog = dialog;
        this.deviceService = deviceService;
        this.authService = authService;
        this.currentEvents = [];
        this.futureEvents = [];
        this.pastEvents = [];
        this.allEvents = [];
        this.users = [];
        this.accountingYear = undefined;
        this.viewMode = EventViewMode.Admin;
        this.enumViewMode = EventViewMode;
        this.eventControl = new FormControl();
        this.hideNames = false;
        if (this.deviceService.isMobile()) {
            this.viewMode = EventViewMode.SimplifiedAdmin;
        }
    }
    EventsAdminComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadEvents();
        this.loadAccountingYear();
        this.loadUsers();
        //slection dropdown for shift overview
        this.eventControl.valueChanges.subscribe(function (value) {
            _this.selectedEvent = _this.allEvents.find(function (event) { return event.id === value; });
        });
    };
    //Load events
    EventsAdminComponent.prototype.loadEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var today, wpLoaded;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        today = new Date();
                        this.pastEvents = [];
                        this.futureEvents = [];
                        this.currentEvents = [];
                        return [4 /*yield*/, this.dataModel.getEventsWithSubData(false, false, true, true, false, "", "", "==", false)];
                    case 1:
                        wpLoaded = _a.sent();
                        if (!wpLoaded.result) {
                            this.common.showErrorToast('Events konnten nicht geladen werden');
                            this.log.error(wpLoaded.errorMessage);
                        }
                        else {
                            this.allEvents = wpLoaded.data;
                            this.allEvents.forEach(function (element) {
                                var start = new Date(element.start.seconds * 1000);
                                var end = new Date(element.end.seconds * 1000);
                                //past
                                if (today > end) {
                                    _this.pastEvents.push(element);
                                }
                                //future
                                else if (today < start) {
                                    _this.futureEvents.push(element);
                                }
                                //current
                                else {
                                    _this.currentEvents.push(element);
                                }
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    //Loads all user
    EventsAdminComponent.prototype.loadUsers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.common.loadAllUsers(function (res, allUsersData, options) {
                    if (res) {
                        _this.users = allUsersData;
                        _this.userOptions = options;
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    //loads the current accounting year
    EventsAdminComponent.prototype.loadAccountingYear = function () {
        var _this = this;
        this.dataModel.loadCurrentAccountingYear().then(function (fulfilled) {
            _this.accountingYear = fulfilled;
        }, function (rejectMsg) {
            _this.common.showErrorToast('Konnte Daten des Abrechnungsjahr nicht laden');
            _this.log.error(rejectMsg, EventsAdminComponent.name);
        });
    };
    //Gets the state of this event: not started, running, past
    EventsAdminComponent.prototype.getRunningState = function (event) {
        return this.common.getRunningState(event);
    };
    EventsAdminComponent.prototype.shiftIsPassed = function (event) {
        return this.common.getRunningState(event) == EventState.Past;
    };
    //Opens a dialog to add an event
    EventsAdminComponent.prototype.addEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.accountingYear == undefined) {
                    this.common.showErrorToast('Daten zum Abrechnungsjahr nicht geladen');
                    return [2 /*return*/];
                }
                data = {
                    result: 0,
                    allUserData: this.users,
                    userOptions: this.userOptions,
                    idAccountingYear: this.accountingYear.id,
                };
                this.dialog
                    .open(AddEventComponent, {
                    width: '550px',
                    data: data,
                })
                    .afterClosed()
                    .subscribe(function (result) {
                    if (result.result == 1) {
                        _this.loadEvents();
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    //Raised when something has change in the child component
    EventsAdminComponent.prototype.eventChanged = function (change) {
        this.loadEvents();
    };
    //Called when sub compoenent is loaded
    EventsAdminComponent.prototype.subComponentIsLoaded = function () {
    };
    //Handle swipe between tabs
    EventsAdminComponent.prototype.swipe = function (e, when) {
        var coord = [
            e.changedTouches[0].clientX,
            e.changedTouches[0].clientY,
        ];
        var time = new Date().getTime();
        if (when === 'start') {
            this.swipeCoord = coord;
            this.swipeTime = time;
        }
        else if (when === 'end') {
            var direction = [
                coord[0] - this.swipeCoord[0],
                coord[1] - this.swipeCoord[1],
            ];
            var duration = time - this.swipeTime;
            if (duration < 1000 && //
                Math.abs(direction[0]) > 30 && // Long enough
                Math.abs(direction[0]) > Math.abs(direction[1] * 3)) {
                if (this.selectedTab == undefined)
                    this.selectedTab = 0;
                // Horizontal enough
                var swipe = direction[0] < 0 ? 'next' : 'previous';
                console.info(swipe);
                if (swipe === 'next') {
                    var isFirst = this.selectedTab === 0;
                    if (this.selectedTab <= 3) {
                        this.selectedTab = isFirst ? 1 : this.selectedTab + 1;
                    }
                    console.log('Swipe left — INDEX: ' + this.selectedTab);
                }
                else if (swipe === 'previous') {
                    var isLast = this.selectedTab === 4;
                    if (this.selectedTab >= 1) {
                        this.selectedTab = this.selectedTab - 1;
                    }
                    console.log('Swipe right — INDEX: ' + this.selectedTab);
                }
            }
        }
    };
    /**
     * Checks if the current user is an events admin.
     * @returns {boolean} Returns true if the user is an events admin, false otherwise.
     */
    EventsAdminComponent.prototype.onlyEventsAdmin = function () {
        return this.authService.isEventsAdmin;
    };
    EventsAdminComponent.prototype.getShiftsByDay = function (workPackages) {
        var groupedByDay = groupBy(workPackages, function (wp) { return wp.start.toDate().toLocaleDateString(); });
        return Object.keys(groupedByDay).map(function (day) {
            var date = new Date(day);
            var dayName = date.toLocaleDateString('de-DE', { weekday: 'long' });
            var shifts = groupedByDay[day];
            //sort by shift names
            shifts.sort(function (a, b) {
                return a[Properties.Type] < b[Properties.Type] ? -1 : 1;
            });
            return {
                day: dayName,
                shifts: shifts
            };
        });
    };
    EventsAdminComponent.prototype.onChangeShowNames = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (event) {
                    this.hideNames = event.checked;
                }
                return [2 /*return*/];
            });
        });
    };
    EventsAdminComponent.prototype.calcFreePlaces = function (shift) {
        var _a;
        if (this.common.isConstructionOrDismantling(shift)) {
            return "Keine Begrenzung";
        }
        var res = shift.minParticipants - ((_a = shift.participants) === null || _a === void 0 ? void 0 : _a.length);
        if (res <= 0)
            return "Keine freien Plätze";
        return res.toString();
    };
    EventsAdminComponent.ɵfac = function EventsAdminComponent_Factory(t) { return new (t || EventsAdminComponent)(i0.ɵɵdirectiveInject(i1.DataModelService), i0.ɵɵdirectiveInject(i2.CommonFunctionsService), i0.ɵɵdirectiveInject(i3.LogService), i0.ɵɵdirectiveInject(i4.MatDialog), i0.ɵɵdirectiveInject(i5.DeviceDetectorService), i0.ɵɵdirectiveInject(i6.AuthService)); };
    EventsAdminComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EventsAdminComponent, selectors: [["app-events-admin"]], viewQuery: function EventsAdminComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatAccordion, 1);
        } if (rf & 2) {
            var _t = void 0;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordion = _t.first);
        } }, decls: 26, vars: 12, consts: [[3, "touchstart", "touchend"], ["mat-stretch-tabs", "true", "mat-align-tabs", "center", 3, "selectedIndex", "selectedIndexChange"], ["mat-tab-label", ""], ["class", "event-view", 4, "ngFor", "ngForOf"], ["class", "no-events-text", 4, "ngIf"], ["fxLayout", "column", "fxLayoutAlign", "center center", "fxLayoutGap", "20px"], ["appearance", "fill", 2, "padding-top", "20px", "padding-left", "5%", "padding-right", "5%", "padding-bottom", "20px"], [3, "formControl"], [3, "value", 4, "ngFor", "ngForOf"], ["class", "footer-icon", "style", "padding-left: 5%;", "matTooltip", "Namen ausblenden", "color", "primary", 3, "checked", "change", 4, "ngIf"], ["fxLayout", "column", "fxLayoutAlign", "start stretch", "fxLayoutGap", "20px", "style", "padding: 2%", 4, "ngIf"], ["mat-fab", "", "style", "z-index: 9998 !important", "class", "history-btn", "color", "primary", "aria-label", "Event hinzuf\u00FCgen", 3, "click", 4, "ngIf"], [1, "event-view"], [3, "data", "users", "userOptions", "accountingYear", "viewMode", "componentChanged", "componentLoaded"], [1, "no-events-text"], [3, "value"], ["matTooltip", "Namen ausblenden", "color", "primary", 1, "footer-icon", 2, "padding-left", "5%", 3, "checked", "change"], ["fxLayout", "column", "fxLayoutAlign", "start stretch", "fxLayoutGap", "20px", 2, "padding", "2%"], [2, "text-align", "center", "background-color", "lightgrey", "margin-bottom", "20px"], ["fxLayout", "column", "fxLayoutGap", "10px", 4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxLayoutGap", "10px"], ["mat-table", "", 1, "mat-elevation-z8", "responsive-table", 3, "dataSource"], ["matColumnDef", "name"], [4, "matHeaderCellDef"], [4, "matCellDef"], ["matColumnDef", "responsiblePerson"], ["matColumnDef", "start"], ["matColumnDef", "end"], ["matColumnDef", "freePlaces"], ["matColumnDef", "participants"], [4, "matHeaderRowDef"], [4, "matRowDef", "matRowDefColumns"], [1, "participants-container"], ["class", "participant-cell", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "participant-cell", 3, "ngClass"], [4, "ngIf"], ["mat-fab", "", "color", "primary", "aria-label", "Event hinzuf\u00FCgen", 1, "history-btn", 2, "z-index", "9998 !important", 3, "click"], [1, "history-icon"]], template: function EventsAdminComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("touchstart", function EventsAdminComponent_Template_div_touchstart_0_listener($event) { return ctx.swipe($event, "start"); })("touchend", function EventsAdminComponent_Template_div_touchend_0_listener($event) { return ctx.swipe($event, "end"); });
            i0.ɵɵelementStart(1, "mat-tab-group", 1);
            i0.ɵɵlistener("selectedIndexChange", function EventsAdminComponent_Template_mat_tab_group_selectedIndexChange_1_listener($event) { return ctx.selectedTab = $event; });
            i0.ɵɵelementStart(2, "mat-tab");
            i0.ɵɵtemplate(3, EventsAdminComponent_ng_template_3_Template, 1, 0, "ng-template", 2);
            i0.ɵɵtemplate(4, EventsAdminComponent_div_4_Template, 2, 5, "div", 3);
            i0.ɵɵtemplate(5, EventsAdminComponent_div_5_Template, 3, 0, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "mat-tab");
            i0.ɵɵtemplate(7, EventsAdminComponent_ng_template_7_Template, 1, 0, "ng-template", 2);
            i0.ɵɵtemplate(8, EventsAdminComponent_div_8_Template, 2, 5, "div", 3);
            i0.ɵɵtemplate(9, EventsAdminComponent_div_9_Template, 3, 0, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "mat-tab");
            i0.ɵɵtemplate(11, EventsAdminComponent_ng_template_11_Template, 1, 0, "ng-template", 2);
            i0.ɵɵtemplate(12, EventsAdminComponent_div_12_Template, 2, 5, "div", 3);
            i0.ɵɵtemplate(13, EventsAdminComponent_div_13_Template, 3, 0, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "mat-tab");
            i0.ɵɵtemplate(15, EventsAdminComponent_ng_template_15_Template, 1, 0, "ng-template", 2);
            i0.ɵɵelementStart(16, "div", 5);
            i0.ɵɵelementStart(17, "mat-form-field", 6);
            i0.ɵɵelementStart(18, "mat-label");
            i0.ɵɵtext(19, "Event ausw\u00E4hlen");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "mat-select", 7);
            i0.ɵɵtemplate(21, EventsAdminComponent_mat_option_21_Template, 2, 3, "mat-option", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(22, EventsAdminComponent_mat_slide_toggle_22_Template, 2, 1, "mat-slide-toggle", 9);
            i0.ɵɵelement(23, "hr");
            i0.ɵɵtemplate(24, EventsAdminComponent_div_24_Template, 7, 3, "div", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(25, EventsAdminComponent_button_25_Template, 3, 0, "button", 11);
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("selectedIndex", ctx.selectedTab);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.currentEvents);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.currentEvents == null ? null : ctx.currentEvents.length) == 0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.futureEvents);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.futureEvents == null ? null : ctx.futureEvents.length) == 0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.pastEvents);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.pastEvents == null ? null : ctx.pastEvents.length) == 0);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("formControl", ctx.eventControl);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.allEvents);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.selectedEvent);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.selectedEvent);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.viewMode == ctx.enumViewMode.Admin && ctx.onlyEventsAdmin());
        } }, directives: [i7.MatTabGroup, i7.MatTab, i7.MatTabLabel, i8.NgForOf, i8.NgIf, i9.MatFormField, i9.MatLabel, i10.MatSelect, i11.NgControlStatus, i11.FormControlDirective, i12.EventViewComponent, i13.MatOption, i14.MatSlideToggle, i15.MatTooltip, i16.MatCard, i17.MatTable, i17.MatColumnDef, i17.MatHeaderCellDef, i17.MatCellDef, i17.MatHeaderRowDef, i17.MatRowDef, i17.MatHeaderCell, i17.MatCell, i8.NgClass, i17.MatHeaderRow, i17.MatRow, i18.MatButton, i19.MatIcon], pipes: [i8.DatePipe], styles: [".event-view[_ngcontent-%COMP%] {\n  margin: 2% 2% 5% 2%;\n}\n\n@media screen and (max-width: 700px) {\n  .event-view[_ngcontent-%COMP%] {\n    margin: 0;\n  }\n}\n\n.no-events-text[_ngcontent-%COMP%] {\n  margin: auto;\n  width: 75%;\n  padding: 10px;\n  margin-top: 40%;\n  text-align: center;\n  padding-bottom: 80%;\n}\n\n\n\n.occupied[_ngcontent-%COMP%] {\n  background-color: green;\n  color: white;\n  font-weight: bold;\n  text-align: center;\n}\n\n.empty[_ngcontent-%COMP%] {\n  background-color: red;\n  color: white;\n  font-weight: bold;\n  text-align: center;\n}\n\ntable[_ngcontent-%COMP%] {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.responsive-table[_ngcontent-%COMP%] {\n  overflow-x: auto;\n}\n\n.participants-container[_ngcontent-%COMP%] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 10px;\n}\n\n.participant-cell[_ngcontent-%COMP%] {\n  padding: 10px;\n  border: 1px solid #ccc;\n  text-align: center;\n  width: 120px; \n  height: 50px; \n  box-sizing: border-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  word-break: break-word; \n}\n\n@media (max-width: 768px) {\n  .participant-cell[_ngcontent-%COMP%] {\n    width: 80px;\n    font-size: 0.8em;\n  }\n\n  mat-form-field[_ngcontent-%COMP%] {\n    width: 100%;\n  }\n}\n\n.mat-column-name[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 15% !important;\n      flex: 0 0 15% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.mat-column-responsiblePerson[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 15% !important;\n      flex: 0 0 15% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.mat-column-start[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 5% !important;\n      flex: 0 0 5% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.mat-column-end[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 5% !important;\n      flex: 0 0 5% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.mat-column-freePlaces[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 10% !important;\n      flex: 0 0 10% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.mat-column-participants[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 50% !important;\n      flex: 0 0 50% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */"] });
    return EventsAdminComponent;
}());
export { EventsAdminComponent };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EventsAdminComponent, [{
        type: Component,
        args: [{
                selector: 'app-events-admin',
                templateUrl: './events-admin.component.html',
                styleUrls: ['./events-admin.component.css'],
            }]
    }], function () { return [{ type: i1.DataModelService }, { type: i2.CommonFunctionsService }, { type: i3.LogService }, { type: i4.MatDialog }, { type: i5.DeviceDetectorService }, { type: i6.AuthService }]; }, { accordion: [{
            type: ViewChild,
            args: [MatAccordion]
        }] }); })();
//# sourceMappingURL=events-admin.component.js.map